<template>
    <div name="improvement-banner" class="banner">
        <span class="title">불편함, 이렇게 개선했어요!</span>
        <span class="description" style="margin-top: 8px;">
            여러분이 남겨주신 ‘불편함' 덕분에<br>
            많은 분들의 하루가 더 편안해지고 있습니다.<br><br>
            언제든 떠오르는 불편함이 있다면 또 알려주세요.<br><br>
            함께 만드는 더 나은 미래 <br>
            <span style="font-weight: 700;">솔닥 컨시어지가 함께하겠습니다.</span>
        </span>
        <div class="button" style="margin-top: 20px;" @click="postUncomfortable">불편 접수하러 가기 →</div>
    </div>  
</template>

<script>
export default {
    name: 'improvementBanner',
    methods: {
        postUncomfortable: function()
        {
            this.$emit('postUncomfortable')
        }
    }
}  
</script>

<style scoped>
    .banner {
        width: 100%;
        display: flex;
        flex-direction: column;
    }
    .title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 28px; /* 116.667% */
    }
    .description {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px; /* 142.857% */
    }
    .button {
        display: flex;
        padding:16px 0;
        width: 152px;
        justify-content: center;
        align-items: center;    
        box-sizing: border-box;
        color: var(--Gray-00, #FFF);
        border-radius: 100px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: #1D4A94;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 142.857% */
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/m_uncomfortable/improvements/ImprovementBanner.vue